import React from "react";
import Card from "../../components/card/Card";
import NsDataTable from "../../components/tabelle/NsDataTable";

export default function ConfLingueView({
                                           lingue,
                                           translate,
                                       }) {

    return (
        <Card
            icon={'fas fa-flags'}
            title={'Lingue'}
        >
            <NsDataTable
                data={lingue}
                columns={[
                    {
                        name: translate('Codice'),
                        selector: row => row.codice,
                        sortable: true,
                    },
                    {
                        name: translate('Descrizione'),
                        selector: row => row.descrizione,
                        sortable: true,
                    }
                ]}
            />
        </Card>
    );
}
